let _initProto, _initClass, _init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_triggerTarget, _init_extra_triggerTarget, _init_menuTarget, _init_extra_menuTarget, _init_changeEvent, _init_extra_changeEvent, _init_closeEvent, _init_extra_closeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, bound, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { PopoverController, shouldDismissPopoverPointer } from "../shared/popover-controller";
const MENU_GAP = 6;
let _RuiMenuButton;
class RuiMenuButton extends RadiantElement {
  static {
    ({
      e: [_init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_triggerTarget, _init_extra_triggerTarget, _init_menuTarget, _init_extra_menuTarget, _init_changeEvent, _init_extra_changeEvent, _init_closeEvent, _init_extra_closeEvent, _initProto],
      c: [_RuiMenuButton, _initClass]
    } = _applyDecs(this, [customElement("rui-menu-button")], [[prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "open"], [prop({
      type: String,
      defaultValue: "bottom-start"
    }), 0, "placement"], [query({
      ref: "trigger"
    }), 0, "triggerTarget"], [query({
      ref: "menu"
    }), 0, "menuTarget"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [event({
      name: "rui-close",
      bubbles: true,
      composed: true
    }), 0, "closeEvent"], [[bound, onUpdated(["open", "placement"])], 2, "syncOpenState"], [onEvent({
      document: true,
      type: "pointerdown"
    }), 2, "onDocumentPointerDown"], [onEvent({
      ref: "trigger",
      type: "click"
    }), 2, "onTriggerClick"], [onEvent({
      ref: "trigger",
      type: "keydown"
    }), 2, "onTriggerKeydown"], [onEvent({
      ref: "menu",
      type: "keydown"
    }), 2, "onMenuKeydown"], [onEvent({
      selector: '[role="menuitem"]',
      type: "click"
    }), 2, "onItemClick"]], 0, void 0, RadiantElement));
  }
  open = (_initProto(this), _init_open(this));
  placement = (_init_extra_open(this), _init_placement(this));
  triggerTarget = (_init_extra_placement(this), _init_triggerTarget(this));
  menuTarget = (_init_extra_triggerTarget(this), _init_menuTarget(this));
  changeEvent = (_init_extra_menuTarget(this), _init_changeEvent(this));
  closeEvent = (_init_extra_changeEvent(this), _init_closeEvent(this));
  menuId = (_init_extra_closeEvent(this), `rui-menu-${Math.random().toString(36).slice(2, 9)}`);
  popoverController = null;
  pendingFocus = null;
  onConnected() {
    this.syncOpenState();
  }
  disconnectedCallback() {
    this.popoverController?.destroy();
    this.popoverController = null;
    super.disconnectedCallback();
  }
  getItems() {
    return Array.from(this.menuTarget?.querySelectorAll('[role="menuitem"]') ?? []).filter(item => !item.hidden && item.getAttribute("aria-disabled") !== "true");
  }
  getSearchInput() {
    return this.menuTarget?.querySelector("[data-autocomplete-input]") ?? null;
  }
  ensurePopoverController() {
    if (!this.popoverController) {
      this.popoverController = new PopoverController({
        getAnchor: () => this.triggerTarget,
        getFloating: () => this.menuTarget,
        getOpen: () => this.open,
        getPlacement: () => this.placement,
        gap: MENU_GAP,
        portal: false
      });
    }
    return this.popoverController;
  }
  syncOpenState() {
    if (!this.triggerTarget || !this.menuTarget) return;
    this.menuTarget.id = this.menuId;
    this.triggerTarget.setAttribute("aria-controls", this.menuId);
    this.triggerTarget.setAttribute("aria-haspopup", "menu");
    this.triggerTarget.setAttribute("aria-expanded", String(this.open));
    this.menuTarget.toggleAttribute("hidden", !this.open);
    const controller = this.ensurePopoverController();
    controller.updateConfig({
      getPlacement: () => this.placement,
      getOpen: () => this.open
    });
    controller.sync();
    const focus = this.pendingFocus;
    this.pendingFocus = null;
    if (!focus) return;
    if (focus === "trigger") {
      this.triggerTarget?.focus();
      return;
    }
    const search = this.getSearchInput();
    if (search) {
      search.focus();
      return;
    }
    if (focus === "first") this.getItems()[0]?.focus();
    if (focus === "last") {
      const items = this.getItems();
      items[items.length - 1]?.focus();
    }
  }
  setOpen(next, focus = null) {
    const wasOpen = this.open;
    this.pendingFocus = focus;
    this.open = next;
    if (wasOpen && !next) this.closeEvent.emit();
    if (wasOpen === next) this.syncOpenState();
  }
  onDocumentPointerDown(event2) {
    if (!this.open) return;
    const target = event2.target;
    if (!shouldDismissPopoverPointer(this.triggerTarget, this.menuTarget, target)) return;
    this.setOpen(false);
  }
  onTriggerClick() {
    this.setOpen(!this.open, this.open ? null : "first");
  }
  onTriggerKeydown(event2) {
    switch (event2.key) {
      case "ArrowDown":
      case "Enter":
      case " ":
        event2.preventDefault();
        this.setOpen(true, "first");
        break;
      case "ArrowUp":
        event2.preventDefault();
        this.setOpen(true, "last");
        break;
      default:
        break;
    }
  }
  onMenuKeydown(event2) {
    const items = this.getItems();
    const current = document.activeElement;
    const index = current ? items.indexOf(current) : -1;
    switch (event2.key) {
      case "ArrowDown":
        {
          event2.preventDefault();
          const next = items[(index + 1) % items.length];
          next?.focus();
          break;
        }
      case "ArrowUp":
        {
          event2.preventDefault();
          const prev = items[(index - 1 + items.length) % items.length];
          prev?.focus();
          break;
        }
      case "Home":
        event2.preventDefault();
        items[0]?.focus();
        break;
      case "End":
        event2.preventDefault();
        items[items.length - 1]?.focus();
        break;
      case "Escape":
        event2.preventDefault();
        this.setOpen(false, "trigger");
        break;
      case "Tab":
        this.setOpen(false);
        break;
      case "Enter":
      case " ":
        if (current && items.includes(current)) {
          event2.preventDefault();
          this.activateItem(current);
        }
        break;
      default:
        break;
    }
  }
  onItemClick(event2) {
    const item = event2.target.closest('[role="menuitem"]');
    if (!item || !this.contains(item)) return;
    this.activateItem(item);
  }
  activateItem(item) {
    const value = item.getAttribute("data-value") || item.textContent?.trim() || "";
    this.changeEvent.emit({
      value
    });
    this.setOpen(false, "trigger");
  }
  static {
    _initClass();
  }
}
export { _RuiMenuButton as RuiMenuButton };